export default {"src":"/_next/static/media/document_filled.40e85b49.svg","height":24,"width":24};